import { ToastMessage } from './ToastMessage';
import { useFlash } from '@/hooks';

export function ToastMessageHost() {
    const messages = useFlash();

    return (
        <div
            className={
                'pointer-events-none fixed top-10 z-50 flex w-full flex-col flex-wrap items-center gap-4 p-4'
            }
        >
            {Object.entries(messages).map(([_, message]) => (
                <ToastMessage message={message} key={Math.random()} />
            ))}
        </div>
    );
}
